module.exports = __webpack_public_path__ + "media/assets/images/flags/tj-4def77027a28a29aa6e3a85fc1c48c10.svg";